module.exports = __webpack_public_path__ + "img/bg-2.50b1419f.png";